import { createContext, useContext } from "react";

interface SplashScreenContextProps {
  disableSplashScreen: () => void;
  enableSplashScreen: () => void;
  isSplashScreenVisible: boolean;
}

const SplashScreenContext = createContext<SplashScreenContextProps | undefined>(
  undefined,
);

const useSplashScreen = (): SplashScreenContextProps => {
  const context = useContext(SplashScreenContext);
  if (!context) {
    throw new Error(
      "useSplashScreen must be used within a SplashScreenProvider",
    );
  }
  return context;
};

export type { SplashScreenContextProps };
export { SplashScreenContext, useSplashScreen };
